/**
 * 运营 - 同步商户信息（记录列表）
 */
<template>
  <div class="merchant-sync-page">
    <el-breadcrumb separator-class="el-icon-arrow-right" class="page-breadcrumb">
      <el-breadcrumb-item :to="{ path: '/oms/customerSignOrder' }">运营</el-breadcrumb-item>
      <el-breadcrumb-item>同步商户信息</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="search-section">
      <el-form :inline="true" :model="formInline" size="small" class="search-form">
        <el-form-item label="商户名称">
          <el-input
            v-model="formInline.merchantName"
            placeholder="请输入商户名称"
            clearable
            class="search-input"
          />
        </el-form-item>
        <el-form-item label="服务商名称">
          <el-input
            v-model="formInline.providerName"
            placeholder="请输入服务商名称"
            clearable
            class="search-input"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
          <el-button icon="el-icon-refresh-left" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="toolbar">
      <el-button size="small" type="primary" icon="el-icon-refresh" @click="goSyncPage">
        同步
      </el-button>
    </div>

    <el-card shadow="hover" class="table-card">
      <el-table
        size="small"
        :data="listData"
        highlight-current-row
        v-loading="loading"
        element-loading-text="加载中..."
        empty-text="暂无同步记录"
        style="width: 100%"
        border
      >
        <el-table-column prop="id" label="记录ID" min-width="90" show-overflow-tooltip />
        <el-table-column prop="merchantName" label="商户名称" min-width="160" show-overflow-tooltip>
          <template slot-scope="scope">
            <span
              class="copyable-cell"
              title="双击复制"
              @dblclick="copyToClipboard(scope.row.merchantName)"
            >
              {{ scope.row.merchantName || '--' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="providerName" label="服务商名称" min-width="160" show-overflow-tooltip>
          <template slot-scope="scope">
            <span
              class="copyable-cell"
              title="双击复制"
              @dblclick="copyToClipboard(scope.row.providerName)"
            >
              {{ scope.row.providerName || '--' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="channel" label="服务商编码" min-width="130" show-overflow-tooltip />
        <el-table-column prop="syncStatus" label="同步状态" min-width="100">
          <template slot-scope="scope">
            <el-tag size="small" effect="plain" :type="getSyncStatusTagType(scope.row.syncStatus)">
              {{ getSyncStatusText(scope.row.syncStatus) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" min-width="180" show-overflow-tooltip />
        <el-table-column prop="createdAt" label="创建时间" min-width="160" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ formatDateTime(scope.row.createdAt) }}
          </template>
        </el-table-column>
        <el-table-column prop="updatedAt" label="更新时间" min-width="160" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ formatDateTime(scope.row.updatedAt) }}
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-wrap">
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather" />
      </div>
    </el-card>
  </div>
</template>

<script>
import Pagination from '../../components/Pagination';
import { getMerchantSyncRecords } from '../../api/userMG';

const SYNC_STATUS_MAP = {
  0: { label: '待同步', type: 'info' },
  1: { label: '同步中', type: 'warning' },
  2: { label: '成功', type: 'success' },
  3: { label: '失败', type: 'danger' }
};

export default {
  name: 'MerchantSync',
  components: {
    Pagination
  },
  data() {
    return {
      loading: false,
      formInline: {
        page: 1,
        pageSize: 10,
        merchantName: '',
        providerName: ''
      },
      listData: [],
      pageparm: {
        page: 1,
        pageSize: 10,
        total: 0
      }
    };
  },
  created() {
    this.getList();
  },
  methods: {
    goSyncPage() {
      this.$router.push({ path: '/oms/merchantSyncInfo' });
    },
    getList() {
      this.loading = true;
      const params = {
        page: this.formInline.page,
        pageSize: this.formInline.pageSize,
        merchantName: this.formInline.merchantName || undefined,
        providerName: this.formInline.providerName || undefined
      };
      getMerchantSyncRecords(params)
        .then((res) => {
          if (res && (res.msg === 'success' || res.code === 0)) {
            const data = res.data || {};
            this.listData = data.items || data.list || data.records || [];
            this.pageparm.total = data.totalCount || data.total || data.count || 0;
            this.pageparm.page = data.page || this.formInline.page;
            this.pageparm.pageSize = data.pageSize || this.formInline.pageSize;
          } else {
            this.listData = [];
            this.pageparm.total = 0;
            this.$message.error((res && (res.msg || res.message)) || '获取同步记录失败');
          }
        })
        .catch((err) => {
          this.listData = [];
          this.pageparm.total = 0;
          const data = err && err.response && err.response.data;
          this.$message.error((data && (data.msg || data.message)) || (err && err.message) || '获取同步记录失败');
        })
        .finally(() => {
          this.loading = false;
        });
    },
    search() {
      this.formInline.page = 1;
      this.pageparm.page = 1;
      this.getList();
    },
    reset() {
      this.formInline = {
        page: 1,
        pageSize: 10,
        merchantName: '',
        providerName: ''
      };
      this.pageparm.page = 1;
      this.getList();
    },
    callFather(parm) {
      this.formInline.page = parm.page;
      this.formInline.pageSize = parm.pageSize;
      this.pageparm.page = parm.page;
      this.pageparm.pageSize = parm.pageSize;
      this.getList();
    },
    getSyncStatusTagType(status) {
      const item = SYNC_STATUS_MAP[status];
      return (item && item.type) || 'info';
    },
    getSyncStatusText(status) {
      const item = SYNC_STATUS_MAP[status];
      return (item && item.label) || '--';
    },
    formatDateTime(timestamp) {
      if (!timestamp) return '--';
      const timestampMs = String(timestamp).length <= 10 ? timestamp * 1000 : timestamp;
      const date = new Date(timestampMs);
      if (Number.isNaN(date.getTime())) return '--';
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')} ${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}:${String(date.getSeconds()).padStart(2, '0')}`;
    },
    copyToClipboard(text) {
      const str = text != null && text !== '' ? String(text) : '';
      if (!str) return;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard
          .writeText(str)
          .then(() => {
            this.$message.success('已复制');
          })
          .catch(() => {
            this.fallbackCopy(str);
          });
      } else {
        this.fallbackCopy(str);
      }
    },
    fallbackCopy(text) {
      const el = document.createElement('textarea');
      el.value = text;
      el.style.position = 'fixed';
      el.style.opacity = '0';
      document.body.appendChild(el);
      el.select();
      try {
        document.execCommand('copy');
        this.$message.success('已复制');
      } catch (e) {
        this.$message.warning('复制失败');
      }
      document.body.removeChild(el);
    }
  }
};
</script>

<style scoped>
.merchant-sync-page {
  padding-bottom: 24px;
}
.page-breadcrumb {
  margin-bottom: 0;
}
.search-section {
  margin-top: 24px;
  margin-bottom: 16px;
  padding: 16px 20px;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #ebeef5;
}
.search-form .el-form-item {
  margin-bottom: 10px;
  margin-right: 20px;
}
.search-form .search-input {
  width: 220px;
}
.toolbar {
  margin-bottom: 16px;
}
.table-card {
  border-radius: 8px;
  overflow: hidden;
}
.table-card >>> .el-card__body {
  padding: 20px;
}
.pagination-wrap {
  margin-top: 16px;
}
.copyable-cell {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/oms/merchantSync.vue